import React, { useState, useEffect, useMemo, useCallback } from 'react';
import buildMenuItems from '../_helpers/buildMenuItems';

// Components
import Select from '@material-ui/core/Select';

// Style
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';
const styles = defineStyles(theme => {
  return {
    root: {
      marginBottom: theme.spacing(2),
    },
    selectHeader: {
      fontSize: 13,
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(1),
    },
    select: {
      minWidth: '100%',
    },
  };
});

interface Props {
  category: any;
  onChange: (value: any, index: number) => void;
  globalConfig: any;
  selectInputIndex: number;
  classes: Classes<typeof styles>;
}

function SelectInput(props: Props) {
  const { classes, onChange, category, selectInputIndex, globalConfig } = props;
  const initialState = category.children.length === 1 ? 0 : -1;
  const [value, setValue] = useState(initialState);

  // On Mount, it will default to the only child if the category only has one option
  useEffect(() => {
    if (value !== -1) {
      const { type, name } = category.children[value];
      const output =
        type === 'category' ? globalConfig.categories[name] : globalConfig.fields[name];

      onChange(output, selectInputIndex);
    }
  }, []);

  const headerDisplayName = selectInputIndex === 0 ? 'Sub Category' : 'Attribute Type';

  const menuItems = useMemo(
    () => buildMenuItems(category.children, globalConfig, `Select ${headerDisplayName}`),
    [category.children],
  );

  const handleChange = useCallback(
    e => {
      const menuItemIndex = e.target.value;
      setValue(menuItemIndex);
      if (menuItemIndex !== -1) {
        const { type, name } = category.children[menuItemIndex];
        const output =
          type === 'category' ? globalConfig.categories[name] : globalConfig.fields[name];

        onChange(output, selectInputIndex);
      } else {
        onChange(undefined, selectInputIndex);
      }
    },
    [onChange],
  );

  return (
    <div className={classes.root} key={selectInputIndex}>
      <div className={classes.selectHeader}> {headerDisplayName} </div>
      <Select value={value} onChange={handleChange} className={classes.select}>
        {menuItems}
      </Select>
    </div>
  );
}

export default withStyles(styles)(SelectInput);
